import { createContext } from "react";

export interface LocationControlSettings {
  apiKey: string;
  provider: "mapbox" | "pelias";
}

export const LocationControlSettingsContext = createContext<LocationControlSettings>({
  apiKey: "",
  provider: "pelias",
});
